import React from "react";
import "../NFTDetailDesign.css";


const NotExistMsg = ({ title = "No comments yet", msg = "Be the first to share your thoughts and start the conversation!", icon = <i className="fas fa-comments"></i> }) => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center text-center py-5 px-3 text-muted">
            <div className="mb-3" style={{
                fontSize: 48,
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "rgba(0, 0, 0, 0.05)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                {icon}
            </div>
            <div className="fw-semibold mb-2" style={{ fontSize: 18 }}>{title}</div>
            <div className="small" style={{ maxWidth: "300px" }}>{msg}</div>
        </div>
    );
};

export default NotExistMsg;